import { designToken, quickProperty } from '../component-tokens';
import { borderBase, focusState } from './common';
import { sizeAttributes } from './utils';
export const radioButtonData = {
    name: 'radio-button',
    tag: 'chameleon-radio-button',
    reactImports: 'RadioButton',
    attributes: {
        gap: designToken('spacing-02'),
        color: designToken('type-color-default'),
        font: designToken('body-small'),
        'line-height': designToken('spacing-05'),
    },
    sizes: [
        {
            name: 'large',
            attributes: Object.assign({}, sizeAttributes('spacing-05', designToken)),
            children: [
                {
                    name: 'control',
                    attributes: Object.assign({}, sizeAttributes('spacing-05', designToken)),
                },
                {
                    name: 'checked-indicator',
                    attributes: Object.assign(Object.assign({}, sizeAttributes('0.625rem')), { inset: designToken('spacing-01') }),
                },
            ],
        },
    ],
    children: [
        {
            name: 'control',
            attributes: Object.assign(Object.assign(Object.assign({}, sizeAttributes('spacing-04', designToken)), borderBase), { 'border-color': designToken('border-color-default'), 'background-color': designToken('surface-color-default') }),
        },
        {
            name: 'checked-indicator',
            attributes: Object.assign(Object.assign({}, sizeAttributes('spacing-02', designToken)), { 'background-color': designToken('surface-color-brand-default'), inset: quickProperty('3px') }),
        },
    ],
    variants: [
        {
            name: 'enabled',
            attributes: Object.assign(Object.assign({}, borderBase), { 'background-color': designToken('surface-color-default'), 'border-color': designToken('border-color-default') }),
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('interactive-color-secondary-hover'),
                        'border-color': designToken('border-color-default'),
                    },
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('interactive-color-secondary-pressed'),
                        'border-color': designToken('border-color-default'),
                        'box-shadow': quickProperty('none'),
                    },
                },
                {
                    name: 'focus',
                    attributes: Object.assign(Object.assign({}, focusState), { 'background-color': designToken('surface-color-default') }),
                },
            ],
        },
        {
            name: 'disabled',
            attributes: {
                // This needs to be set because FAST sets the opacity to 0.3 by default
                // and we need to override that
                opacity: quickProperty('1'),
            },
            children: [
                {
                    name: 'control',
                    attributes: Object.assign(Object.assign({}, borderBase), { 'background-color': designToken('interactive-color-disabled'), cursor: quickProperty('not-allowed') }),
                },
                {
                    name: 'label',
                    attributes: {
                        cursor: quickProperty('default'),
                        color: designToken('type-color-disabled'),
                    },
                },
                {
                    name: 'checked-indicator',
                    attributes: {
                        'background-color': designToken('icon-color-disabled'),
                    },
                },
            ],
        },
        {
            name: 'checked',
            children: [
                {
                    name: 'control',
                    attributes: Object.assign(Object.assign({}, borderBase), { 'background-color': designToken('interactive-color-secondary-default'), 'border-color': designToken('border-color-default') }),
                    states: [
                        {
                            name: 'hover',
                            attributes: Object.assign(Object.assign({}, borderBase), { 'background-color': designToken('interactive-color-secondary-hover'), 'border-color': designToken('border-color-default') }),
                        },
                        {
                            name: 'focus',
                            attributes: Object.assign(Object.assign({}, focusState), { 'background-color': designToken('surface-color-default') }),
                        },
                        {
                            name: 'active',
                            attributes: Object.assign(Object.assign({}, borderBase), { 'background-color': designToken('interactive-color-secondary-pressed'), 'border-color': designToken('border-color-default'), 'box-shadow': quickProperty('none') }),
                        },
                    ],
                },
            ],
        },
    ],
};
